import React from "react";
import { Link } from "react-router-dom";
import { Card, CountryLabel, Badge, STATUS_SOLID } from "./ui";
import CourtArt from "./ui/CourtArt";
import { CalendarIcon, PinIcon, ArrowRightIcon } from "./ui/icons";
import { formatDateRange, formatNumber } from "../utils";

const STATUS_LABEL = {
  upcoming: "Upcoming",
  ongoing: "Ongoing",
  completed: "Completed",
};

// One tournament card, shared by the home teaser and the tournaments index so
// the two can never drift apart. Images are 16:9 per the design system §16.
const TournamentCard = ({ tournament }) => {
  const to = `/tournamentDetails/${tournament.slug || tournament._id}`;
  const status = tournament.status || "upcoming";

  return (
    <Card padded={false} hoverable className="flex flex-col overflow-hidden">
      <Link to={to} className="relative block aspect-video overflow-hidden bg-bg">
        {tournament.imgUrl ? (
          <img
            src={tournament.imgUrl}
            alt=""
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-300 hover:scale-105"
          />
        ) : (
          <CourtArt seed={tournament.name} label={tournament.city} />
        )}
        <span
          className={`absolute left-3 top-3 inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-semibold shadow-sm ${STATUS_SOLID[status]}`}
        >
          {STATUS_LABEL[status]}
        </span>
        <span className="absolute bottom-3 left-3 inline-flex items-center gap-1.5 rounded-sm bg-white/95 px-2.5 py-1 text-xs font-semibold text-navy shadow-sm">
          <CalendarIcon className="h-3.5 w-3.5" />
          {formatDateRange(tournament.startDate, tournament.endDate)}
        </span>
      </Link>

      <div className="flex flex-1 flex-col p-5">
        <div className="flex items-start justify-between gap-3">
          <Link to={to}>
            <h3 className="font-semibold leading-snug text-navy transition-colors hover:text-primary">
              {tournament.name}
            </h3>
          </Link>
          {tournament.country && (
            <CountryLabel code={tournament.country} variant="flag" />
          )}
        </div>

        <div className="mt-2 flex items-center gap-1.5 text-sm text-muted">
          <PinIcon className="h-4 w-4 shrink-0" />
          <span className="truncate">
            {[tournament.city, tournament.venue].filter(Boolean).join(" · ") ||
              tournament.location}
          </span>
        </div>

        <div className="mt-4 flex items-center justify-between border-t border-border pt-4">
          {tournament.category && (
            <Badge tone="primary">{tournament.category}</Badge>
          )}
          <span className="tabular text-sm font-semibold text-navy">
            {formatNumber(tournament.rankingPoints)} pts
          </span>
        </div>

        <Link
          to={to}
          className="mt-4 inline-flex items-center justify-between text-sm font-semibold text-primary hover:text-primary-hover"
        >
          {status === "completed" ? "Results & Standings" : "View Details"}
          <ArrowRightIcon className="h-4 w-4" />
        </Link>
      </div>
    </Card>
  );
};

export default TournamentCard;
